import React, { useState } from "react";
import ReactDOM from "react-dom";
import { createCampaign } from "../../modules/Campaign";
import { showSpinner, closeSpinner, modal } from "../../modules/Dialogs";

const CreateCampaignModal = ({ show, onClose, onSuccess, userDetails }) => {
  const [name, setName] = useState("");
  const [audience, setAudience] = useState("");
  const [creating, setCreating] = useState(false);

  const handleClose = () => {
    setName("");
    setAudience("");
    onClose();
  };

  const handleCreate = () => {
    if (!name.trim()) return;
    setCreating(true);
    showSpinner();

    const payload = {
      name: name.trim(),
      description: audience.trim(),
    };

    createCampaign(
      payload,
      (resStatus, responseString, resJson) => {
        closeSpinner();
        setCreating(false);
        if (resStatus == 200 || resStatus == "200") {
          const newCampaign = resJson?.data || {
            _id: resJson?._id,
            id: resJson?.id,
            name: name.trim(),
          };
          setName("");
          setAudience("");
          onSuccess(newCampaign);
          modal(resJson?.message || responseString || "Campaign created successfully!");
        } else {
          modal(resJson?.message || responseString || "Failed to create campaign.");
        }
      },
      userDetails?.jwttoken,
    );
  };

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="create-campaign-overlay">
      <div className="create-campaign-modal">
        <div className="create-campaign-header">
          <div>
            <h3>Create campaign</h3>
            <p className="coupon-description">
              Add internal context for this discount code.
            </p>
          </div>
          <button className="modal-close-btn" onClick={handleClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>
        <div className="create-campaign-body">
          <div className="form-group">
            <label>
              <strong>Campaign name</strong>
            </label>
            <input
              type="text"
              placeholder="e.g., AFS Students"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>
              <strong>Audience</strong>
            </label>
            <textarea
              placeholder="Who this campaign is for"
              value={audience}
              onChange={(e) => setAudience(e.target.value)}
              rows={4}
            />
          </div>
        </div>
        <div className="create-campaign-footer">
          <button className="btn btn-outline-primary" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleCreate}
            disabled={creating}
          >
            {creating ? "Creating..." : "Create campaign"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CreateCampaignModal;
